import { Component, OnInit } from '@angular/core';
export class HelloWorldComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'tools-hello-world',
  template: `
    <h1>Hello world - dlrow olleH</h1>
  `,
  styles: [`
    h1 {
      color: #000000;
      background-color:#ffff00;
      border: 1px solid #000000;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function HelloWorldComponent_tsickle_Closure_declarations() {
/** @type {?} */
HelloWorldComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
HelloWorldComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
